/**
 * Type definitions and Context object for Google Calendar integration.
 */
import { createContext } from 'react';

/**
 * @typedef {Object} GCalContextValue
 * @property {boolean} isEnabled
 * @property {Array} events
 * @property {Object} syncStatus
 * @property {Function} toggleEnabled
 * @property {Function} getEventsForRange
 * @property {Function} triggerSync
 */

/** @type {import('react').Context<GCalContextValue|null>} */
export const GCalContext = createContext(null);
